import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LoginService } from '../login/service/login.service';
import { error } from 'jquery';
import { SettingsService } from '../../views/layout/settings/service/settings.service';
import { MainService } from '../../views/layout/main/service/mainservice';
import { DashboardService } from '../../views/layout/dashboard/dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  caption: any;
  title: any;
  logo:any;
  logoData:boolean=false;
  appsList:any[]=[];
  appsListNormal:any[]=[];
   myOptions:any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    zIndex: 100000,
    trigger: 'hover',
    shadow: true,
  };
  selectedApp:any='';
   allowedApps:any[]=[];
  constructor( private sanitizer: DomSanitizer,private service:LoginService,private settingService:SettingsService,private mainService:MainService,private dashboardService:DashboardService){}

  ngOnInit(){
      this.dashboardService.getCurrentUser().subscribe({
           next:(response:any)=>{
              this.allowedApps=response['apps'];
               this.appsList = [
                 {
        text: "Voice Agent",
        icon: 'voice-agent',
        url:'/main/postcall/audioRecords',
        name:'SmartAIAgent',
        active:this.isAllowed('SmartAIAgent')
      },       
       {
        text: "Campaign",
        icon: 'campaign',
        url:'/main/postcall/audioRecords',
        name:'Campaign',
        active:this.isAllowed('Campaign')
      },
      {
        text: "Post Call",
        icon: 'bi bi-headset',
        url:'/main/postcall/audioRecords',
        name:'audio',
        active:this.isAllowed('Call')
      },
      {
        text: "Voice Mail",
        icon: 'bi bi-voicemail',
        url:'/main/voiceMailRecords',
        name:'voiceMail',
        active:this.isAllowed('VoiceMail')
      },
      {
        text: "IVR",
        icon: 'bi bi-soundwave',
        url:'/main/ivrRecords',
        name:'ivr',
        active:this.isAllowed('IVR')
      },
      {
        text: "Email",
        icon: 'bi bi-envelope-open',
        url:'/main/email/autoEmailRecords',
        name:'email',
        active:this.isAllowed('Email')
      },
       {
        text: "Email Audit",
        icon: 'bi bi-envelope-open',
        url:'/main/emailAudit',
        name:'emailAudit',
        active:this.isAllowed('EmailAudit')
      },
      {
        text: "Survey / NPS",
        icon: 'bi bi-graph-up-arrow',
        url:'/main/surveyRecords',
        name:'survey',
        active:this.isAllowed('Survey')
      },
      {
        text: "Text",
        icon: 'bi bi-file-text',
        url:'/main/textRecords',
        name:'text',
        active:this.isAllowed('Text')
      },
       {
        text: "Document",
        icon: 'bi bi-file-earmark',
        url:'/main/doc-analytics',
        name:'document',
        active:this.isAllowed('Document')
      },
       {
        text: "Contract",
        icon: 'contract-hand',
        url:'/main/contracts',
        name:'contract',
        active:this.isAllowed('CLM')
      },
       {
        text: "RFP",
        icon: 'contract',
        url:'/main/rfpcontracts',
        name:'rfpcontract',
        active:this.isAllowed('RFP')
      },
      {
        text: "Information Security",
        icon: 'bi-shield-lock',
        url:'/main/infosecurity',
        name:'infosecurity',
        active:this.isAllowed('InfoSec')
      },
     {
        text: "Social Media",
        icon: 'social-media',
        url:'',
        name:'social-media',
        active:this.isAllowed('SocialMedia')
      }
      
    ];

     this.appsListNormal= [{
        text: "AI Assistance",
        icon: 'fa fa-robot',
        url:'https://gpt.absenceassistance.com',
        name:'ai-assist',
        active:this.isAllowed('AIAssistance')
      },
      {
        text: "BI Dashboard and reports",
        icon: 'custom-report',
        url:'https://bimatrix.canstringai.com/timebound',
        name:'reports',
        active:this.isAllowed('Reports')
      }];
             
           },
           error:(errors:HttpErrorResponse)=>{
             
           }
          });
   

   

   this.getCompanyLogoData();
     this.settingService.companylogoBS.subscribe((response:any)=>{
      if(response.hasOwnProperty("value")  && response['value']=="logo"){
        this.getCompanyLogoData();
      }
     });
    
  }
  getCompanyLogoData() {
    this.service.getCompanyLogo().subscribe({
      next: (response:any) => {
        this.logo = response.logo;
        this.caption = response.caption;
        this.title = response.title;
        if(response['logo']){
          this.logoData = true;
        }
        const imageBase64 = response.logo.replace(/b'|'/g, '');
        this.logo =
          this.sanitizer.bypassSecurityTrustResourceUrl(
            'data:image/jpg;base64,' + imageBase64
          );
        
      },
      error: (error:any) => {
        console.log('company logo api error');
      },
    });
  }

  selectedApps(apps:any){
     if(apps['name']=='SmartAIAgent'){
      window.open('https://aiagentcall.canstringai.com/your-agents','target=_blank');
      return ;
    }
    if(apps['name']=='Campaign'){
      window.open('https://aiagentcall.canstringai.com/campaigns','target=_blank');
      return ;
    }
    if(apps['name']=='ai-assist'){
      window.open('https://gpt.absenceassistance.com','target=_blank');
      return ;
    }
    if(apps['name']=='reports'){
      window.open('https://bimatrix.canstringai.com/timebound','target=_blank');
      return ;
    }
    if(apps['name']==='social-media'){
      return;
    }
    localStorage.setItem('selectedApps',apps['name']);
    this.selectedApp = apps['name'];
     this.mainService.selectedAppsBS.next(apps);
  }

  isAllowed(appName:string){
    if(this.allowedApps.length > 0){
       let index = this.allowedApps.findIndex((list:any)=>list['name'].toLowerCase()==appName.toLowerCase());
       if(index !=-1){
        return true;
       }else{
        return false;
       }
    }else{
       return false;
    }
  }

  ngAfterViewInit(){
     this.selectedApp ='';
     setTimeout(()=>{
 this.selectedApp = localStorage.getItem("selectedApps");
     },0)
    
  }

}
